import { Component, Input, Output, EventEmitter } from '@angular/core';

/** Attainment scale labels, index = 0-based level. Shared with the timeline session card. */
export const ATTAINMENT_LABELS = ['Emerging', 'Developing', 'Secure', 'Confident', 'Exceeding'];

@Component({
  selector: 'leap-v2-attainment-bar',
  templateUrl: './leap-v2-attainment-bar.component.html',
  styleUrls: ['./leap-v2-attainment-bar.component.css'],
  standalone: false,
})
export class LeapV2AttainmentBarComponent {
  @Input() step = -1;
  @Input() disabled = false;
  @Output() stepChange = new EventEmitter<number>();

  readonly labels = ATTAINMENT_LABELS;

  get fillWidth(): string {
    return this.step < 0 ? '0%' : `${(this.step / 4) * 100}%`;
  }

  get dotLabel(): string {
    return this.step < 0 ? '–' : String(this.step + 1);
  }

  get stepLabel(): string {
    return this.step < 0 ? 'Not set' : ATTAINMENT_LABELS[this.step];
  }

  get isEmpty(): boolean {
    return this.step < 0;
  }

  onBarClick(event: MouseEvent, track: HTMLElement): void {
    if (this.disabled) return;
    const rect = track.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    const newStep = Math.round(ratio * 4);
    this.step = newStep;
    this.stepChange.emit(newStep);
  }
}
